module.exports = __webpack_public_path__ + "img/CS-ECO13-Profiles.923f7274.jpg";